import { selectors } from '@sloyd/store-base';
import { Guidance, prompt, WarningBar } from '@sloyd/ui';
import { call, delay, fork, select, takeEvery } from 'saga-ts';
import { getBoolean, invokeEvent, l, setBoolean } from 'shared-base';
import { dataGuard } from './helpers/guards';

export const saga = {
  id: 'sloyd.guidance',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['GUIDANCE'],
  },
};

type Verb = 'bootstrap' | 'show';

type Action = {
  type: 'GUIDANCE';
  verb: Verb;
  id: string;
  payload: Json;
};

const map: Record<Verb, any> = {
  bootstrap: bootstrap,
  show: show,
};

export function* show(action: Action) {
  try {
    const appState = yield* select(selectors.raw.$rawAppState);
    const { editMode } = appState;

    yield prompt.popOver({
      component: Guidance,
      componentProps: {
        editMode,
      },
    });
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* bootstrap(action: Action) {
  try {
    const focusMode = yield* select(selectors.base.$focusMode);

    if (focusMode !== 'existing') return;

    const guidanceShown = getBoolean('guidanceShown', false);
    if (!guidanceShown) {
      yield call(show, action);
      setBoolean('guidanceShown', true);
      yield delay(500);
    }

    yield delay(50);

    const isPlayground = yield* select(selectors.base.$isPlayground);
    const playgroundWarningShown = getBoolean('playgroundWarningShown', false);

    if (playgroundWarningShown || !isPlayground) return;

    yield prompt.popOver({
      component: WarningBar,
      componentProps: {},
    });

    setBoolean('playgroundWarningShown', true);
  } catch (err) {
    invokeEvent('send', { err });
  }
}

export function* guidance(action: any) {
  const { verb, id } = action;
  yield delay(50);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  yield dataGuard();

  l(`saga|saga.guidance ${verb} on ${id}`);

  yield* fork(saga, action);
}

export function* root() {
  yield takeEvery('GUIDANCE', guidance);
}
